import React from "react";
import styles from "./UninstallSlackModal.module.scss";
import { BaseModal, ModalHeader } from "@whatslly/ui-components/modals";
import { IModalInstance } from "@whatslly/ui-components/modals/ModalProvider";
import { useTranslation } from "react-i18next";
import { ModalButtons } from "@whatslly/ui-components/ModalButtons";
import { observer } from "mobx-react-lite";
import { SvgV2 } from "@whatslly/ui-components/v2/BaseElements/SvgV2";

interface UninstallSlackModalProps extends IModalInstance<{ confirmed: boolean }> {
  workspaceName?: string;
}

export const UninstallSlackModal: React.FC<UninstallSlackModalProps> = observer(({ closeModal, workspaceName }) => {
  const { t } = useTranslation();

  return (
    <BaseModal
      closeModal={closeModal}
      className={styles.modal}
      bodyClassName={styles.body}
      testId="uninstall-slack-modal"
      closeOnClickOutside={true}
      closeOnEscape={true}
      header={
        <ModalHeader closeModal={() => closeModal({ confirmed: false })}>
          <div className={styles.title}>
            <div className={styles.icon}>
              <SvgV2 iconName={"warning"} />
            </div>
            {t("slack_settings_page.uninstall_modal.title")}
          </div>
        </ModalHeader>
      }
    >
      <div className={styles.content}>
        <p>
          {workspaceName
            ? t("slack_settings_page.uninstall_modal.description_with_workspace", { workspaceName })
            : t("slack_settings_page.uninstall_modal.description")}
        </p>
        <p className={styles.warning}>{t("slack_settings_page.uninstall_modal.warning")}</p>
      </div>

      <ModalButtons
        className={styles.buttons}
        testId="uninstall-slack-confirm"
        submitText={t("slack_settings_page.uninstall_modal.confirm")}
        cancelText={t("slack_settings_page.uninstall_modal.cancel")}
        onSubmit={() => closeModal({ confirmed: true })}
        onCancel={() => closeModal({ confirmed: false })}
      />
    </BaseModal>
  );
});
